import { aboutData } from '@/mocks/home';

export default function SectionAbout() {
  return (
    <section
      id="about"
      className="py-16 md:py-20 bg-background-50"
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block text-xs font-medium text-primary-500 bg-primary-500/10 px-3 py-1 rounded-full mb-4">
            关于我们
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50 mb-4">
            {aboutData.title}
          </h2>
          <p className="text-foreground-400 text-sm md:text-base mb-3">
            {aboutData.subtitle}
          </p>
          <p className="text-foreground-300 text-sm md:text-base leading-relaxed max-w-3xl mx-auto">
            {aboutData.description}
          </p>

          {/* Stats row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mt-10">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}